// Четыре числа за период: сколько висит, сколько долгов, где недобор, что к выплате.
//
// Отдельным компонентом, потому что мест у неё два и они разные по форме.
//
// На компьютере она стоит правой колонкой пульта и отвечает на вопрос «а сколько всего», пока
// человек не выбрал никого конкретного: это и есть «утро финдиректора, ноль кликов».
//
// На планшете в книжной ориентации правой колонки не существует — там одна поверхность за раз,
// и её занимает список людей с деньгами. Числа при этом обязаны остаться достижимыми, иначе
// планшет теряет против компьютера целый экран; поэтому там же они открываются панелью, по
// кнопке в шапке списка. Загрузка, состояния и разметка у обоих случаев одни.

import { Skeleton, ScreenState } from '@/shared/ui/screen-state';

import { useCashTrend, useDashboard } from '../queries';

import { PeriodSummary } from './PeriodSummary';

export function СводкаПодотчёта({ legalEntityId }: { legalEntityId: string | undefined }) {
  const запрос = useDashboard({ legal_entity_id: legalEntityId });
  // Полоса за тридцать дней едет ОТДЕЛЬНО и не держит собой сводку: у неё свой ответ и свой
  // срок жизни в кэше, а числа над пультом человек читает первыми.
  const полоса = useCashTrend({ days: 30, legal_entity_id: legalEntityId });

  return (
    <ScreenState
      data={запрос.data}
      error={запрос.error as never}
      subject='сводку подотчёта за период'
      isEmpty={() => false}
      loading={
        <div className='grid grid-cols-2 gap-4 p-5'>
          {[0, 1, 2, 3].map((номер) => (
            <Skeleton key={номер} className='h-40 w-full rounded-xl' />
          ))}
        </div>
      }
      empty={null}
      onRetry={() => void запрос.refetch()}
    >
      {(данные) => (
        <PeriodSummary data={данные} trend={полоса.data} legalEntityId={legalEntityId} />
      )}
    </ScreenState>
  );
}
